import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const BATTING_CATS = [
  { key: 'homeRuns', label: 'HR' },
  { key: 'battingAverage', label: 'AVG' },
  { key: 'runsBattedIn', label: 'RBI' },
  { key: 'stolenBases', label: 'SB' },
  { key: 'onBasePlusSlugging', label: 'OPS' },
];

const PITCHING_CATS = [
  { key: 'era', label: 'ERA' },
  { key: 'strikeouts', label: 'K' },
  { key: 'wins', label: 'W' },
  { key: 'saves', label: 'SV' },
  { key: 'whip', label: 'WHIP' },
];

const LeaderboardTable = ({ leaderboards, onPlayerClick }) => {
  const [group, setGroup] = useState('bat');
  const [catIdx, setCatIdx] = useState(0);

  const cats = group === 'bat' ? BATTING_CATS : PITCHING_CATS;
  const cat = cats[catIdx];

  const source = group === 'bat' ? leaderboards?.batting : leaderboards?.pitching;
  const leaders = source?.leagueLeaders?.find(l => l.leaderCategory === cat.key)?.leaders ?? [];

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)] flex flex-col">
      <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)] flex items-center justify-between">
        <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Team Leaderboards</span>
        <div className="flex gap-1">
          {['bat', 'pit'].map(v => (
            <button
              key={v}
              onClick={() => { setGroup(v); setCatIdx(0); }}
              className={`text-[9px] font-bold uppercase tracking-widest px-2 py-0.5 border transition-colors ${
                group === v
                  ? 'bg-[#658d71] border-[#a9c9b1] text-white'
                  : 'border-[#658d71] text-[#a9c9b1] hover:text-white'
              }`}
            >
              {v === 'bat' ? 'Batting' : 'Pitching'}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-1 px-3 pt-2 flex-wrap">
        {cats.map((c, i) => (
          <button
            key={c.key}
            onClick={() => setCatIdx(i)}
            className={`text-[9px] font-bold uppercase tracking-widest px-2 py-0.5 border transition-colors ${
              catIdx === i
                ? 'bg-[rgba(216,206,179,0.15)] border-[#d8ceb3] text-[#d8ceb3]'
                : 'border-[#658d71] text-[#658d71] hover:text-[#a9c9b1]'
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="p-3">
        <AnimatePresence mode="wait">
          <motion.div
            key={`${group}-${cat.key}`}
            initial={{ opacity: 0, x: 6 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -6 }}
            transition={{ duration: 0.12 }}
          >
            {leaders.length > 0 ? leaders.map((l, i) => (
              <div
                key={i}
                onClick={() => l.person?.id && onPlayerClick?.(l.person.id, l.person.fullName)}
                className="flex items-center gap-2 py-1.5 border-b border-[rgba(101,141,113,0.2)] last:border-0 cursor-pointer group hover:bg-[rgba(255,255,255,0.03)]"
              >
                <span className={`text-[10px] font-black tabular-nums w-5 text-center shrink-0 ${i === 0 ? 'text-[#d8ceb3]' : 'text-[#658d71]'}`}>
                  {i === 0 ? '★' : i + 1}
                </span>
                <span className="text-[11px] font-bold text-white uppercase tracking-wide truncate flex-1 group-hover:text-[#d8ceb3] transition-colors">
                  {l.person?.fullName?.split(' ').pop() ?? '--'}
                </span>
                <span className="text-[11px] font-black tabular-nums text-[#a9c9b1] shrink-0">{l.value ?? '--'}</span>
              </div>
            )) : (
              <p className="text-[#658d71] text-xs text-center py-6 uppercase tracking-widest">No data available</p>
            )}
          </motion.div>
        </AnimatePresence>
        <p className="text-[8px] text-[#658d71] tracking-widest uppercase mt-2">Click player to view profile</p>
      </div>
    </div>
  );
};

export default LeaderboardTable;